// Firebase initialization (Modular SDK v9+)
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Avoid double-init under hot-reload
export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);

// Designated super-admin (case-insensitive compare)
export const SUPER_ADMIN_EMAIL = (
  process.env.REACT_APP_ADMIN_EMAIL || ""
).toLowerCase();

export const isSuperAdmin = (user) =>
  !!user?.email && user.email.toLowerCase() === SUPER_ADMIN_EMAIL;

// Re-export the raw config for the secondary-app pattern (admin creates managers
// without being signed out)
export { firebaseConfig };
